import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menuFill from '@iconify/icons-eva/menu-fill';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { styled } from '@material-ui/core/styles';
import {
  Box,
  Tooltip,
  Checkbox,
  Typography,
  Autocomplete,
  IconButton,
  OutlinedInput,
  InputAdornment,
  Stack,
  FormControlLabel,
  TextField
} from '@material-ui/core';
//
import { MHidden } from '../../@material-extend';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import MenuPopover from '../../MenuPopover';
import {  useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { objectID } from '../../../utils/objectID';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  height: 'auto',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 2)
}));
const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));
const StyledTextField = styled(TextField, {
  name: "StyledTextField",
})({
  width: 200,
  margin: 8,
  "& .MuiInputBase-root": {
    height: 40,
  },
  "& .MuiFormLabel-root": {
    top: -8
  },
  "& .MuiFormLabel-filled": {
    top: 0
  },
  "& .Mui-focused": {
    top: 0
  }
  //   "& .Mui-focused": {
  //     height: 40
  // }

});
const StyledAutocomplete = styled(Autocomplete, {
  name: "StyledStyledAutocomplete",
})({
  width: 320,
  margin: 8,

  "& .MuiInputBase-root": {
    minHeight: 40,
  },
  "& .MuiFormLabel-root": {
    top: 0
  },
  "& .MuiFormLabel-filled": {
    top: 0
  },
  "& .Mui-focused": {
    top: 0
  }
  //   "& .Mui-focused": {
  //     height: 40
  // }

});
// ----------------------------------------------------------------------

ContactToolbar.propTypes = {
  // mails: PropTypes.number.isRequired,
  // selectedMails: PropTypes.number.isRequired,
  onOpenSidebar: PropTypes.func,
  onToggleDense: PropTypes.func,
  onSelectAll: PropTypes.func,
  onDeselectAll: PropTypes.func
};

export default function ContactToolbar({
  setExport,
  contactList,
  paramSearch,
  selectedContact,
  handleParamAssigner,
  onOpenSidebar,
  onToggleDense,
  onSelectAll,
  onDeselectAll,
  rowsPerPageOptions,
  totalContact,
  resetAllSearch,
  tableHeadContact,
  handleAttributeContact,
  rowsPerPage,
  handleAttributeContactSearch,
  numSelected,
  page,
  handleParamSearch,
  setPage,
  handleChangeRowsPerPage,
  ...other
}) {
  const handleSelectChange = (event) => (event.target.checked ? onSelectAll() : onDeselectAll());
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const { t } = useTranslation();
  const selectedAllContact = selectedContact === contactList && contactList > 0;
  const selectedSomeContact = selectedContact > 0 && selectedContact < contactList;
  const [assignerSelected, setAssignerSelected] = useState([]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const anchorRef = useRef(null);
  const handleOpen = () => {
    setIsOpenFilter(true);
  }
  const handleClose = () => {
    setIsOpenFilter(false);
  }
  const onHandleChangAssigner = (assigners) => {
    setAssignerSelected(assigners)
    handleParamAssigner(assigners.map(assigner => objectID(assigner._id)))
  }

  const onHandleChangeOption = (item, name) => {
    const optionValue = {"target":{"name":name, "value":item?.key}};
    handleParamSearch(optionValue);
    // handleParamSearch(item.map(i => objectID(i._id)))
  }
 
  return (
    <RootStyle {...other}>
      <Stack direction={"row"} flexWrap={"wrap"}>
        {numSelected > 0 ? (
          <Typography component="div" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <SearchStyle
            sx={{ margin: 1, height: 40 }}
            name="text"
            value={paramSearch?.text??""}
            onChange={handleParamSearch}
            placeholder="Tìm kiếm nhanh..."
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
        )}
        {
          tableHeadContact.map((attribute, index) => {
            if (attribute.is_show_search) {
              if (attribute.field_type === "select" || attribute.field_type === "multiselect") {
                if (attribute.field_variable === "assigned_by") {
                  return <StyledAutocomplete
                    key={index}
                    multiple
                    size='small'
                    limitTags={2}
                    id="checkboxes-tags-demo"
                    disableCloseOnSelect
                    options={attribute.field_options}
                    getOptionLabel={(option) => option.full_name}
                    onChange={(event, item) => onHandleChangAssigner(item)}
                    isOptionEqualToValue={(option, item) => objectID(option._id) === objectID(item._id)}
                    value={paramSearch?.assigned_by?assignerSelected:[]}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Người phụ trách"
                        placeholder="Người phụ trách"
                      />
                    )}
                  />
                }
                else {
                  // return <StyledTextField
                  //   key={index}
                  //   label={attribute.field_name}
                  //   name={attribute.field_variable}
                  //   select
                  //   onChange={handleParamSearch}
                  //   value={paramSearch && paramSearch[attribute?.field_variable] ? paramSearch[attribute?.field_variable] : null}
                  // >
                  //   {
                  //     attribute.field_options && attribute.field_options.map((option) => {
                  //       return (
                  //         <MenuItem value={option.key}>{option.label}  </MenuItem>
                  //       )
                  //     })
                  //   }
                  // </StyledTextField>
                  return <StyledAutocomplete
                      key={index}
                      size='small'
                      limitTags={2}
                      id="checkboxes-tags-demo"
                      disableCloseOnSelect
                      options={attribute.field_options}
                      onChange={(event, item) => onHandleChangeOption(item, attribute.field_variable)}
                      renderInput={(params) => (
                          <TextField
                              {...params}
                              variant="outlined"
                              label={attribute.field_name}
                              placeholder={attribute.field_name}
                          />
                      )}
                  />
                }

              } else if (attribute.field_type === "text" || attribute.field_type === "email") {
                return <StyledTextField
                  key={index}
                  label={attribute.field_name}
                  name={attribute.field_variable}
                  onChange={handleParamSearch}
                >
                </StyledTextField>
              } else if (attribute.field_type === "number" || attribute.field_type === "phone") {
                return <StyledTextField
                  key={index}
                  label={attribute.field_name}
                  name={attribute.field_variable}
                  onChange={handleParamSearch}
                  type="number"
                >
                </StyledTextField>
              } else if (attribute?.field_type === "dateTime") {
                return <StyledTextField
                  key={index}
                  label={attribute.field_name}
                  name={attribute.field_variable}
                  sx={{
                    "& .MuiFormLabel-root": {
                      top: 0
                    }
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={handleParamSearch}
                  // type="datetime-local"
                  type="date"
                >
                </StyledTextField>
              //   return <DatePicker
              //   key={index}
              //   label={attribute?.field_name}
              //   name={attribute?.field_variable}
              //   onChange={handleParamSearch}
              //   InputLabelProps={{ shrink: true }}
              //   slotProps={{ textField: { size: 'small' } }}
              // ></DatePicker>
              } else { }
            }

          })
        }
      </Stack>
      <MHidden width="mdUp">
        <IconButton onClick={onOpenSidebar}>
          <Icon icon={menuFill} />
        </IconButton>
      </MHidden>


      <Box sx={{ flexGrow: 1 }} />
      <Stack direction={"row"} spacing={2}>
        <Tooltip title="Làm mới bộ lọc">
          <IconButton onClick={() => resetAllSearch()}>
            <RestartAltIcon />
          </IconButton>
        </Tooltip>
        <Tooltip ref={anchorRef} onClick={handleOpen} title="Lọc thêm thuộc tính">
          <IconButton>
            <Icon icon={roundFilterList} />
          </IconButton>
        </Tooltip>
      </Stack>

      <MenuPopover sx={{ width: 'auto' }} open={isOpenFilter} onClose={handleClose} anchorEl={anchorRef.current} >
        <Stack sx={{ width: '315px', p: 1 }} direction={"column"} justifyContent={'flex-start'}>
          <Typography>Thuộc tính</Typography>
          {tableHeadContact.map((attr) => {
            if (!attr.is_hidden_search) {
              return (
                <FormControlLabel label={t(attr.field_name)} name={attr.field_variable} onChange={handleAttributeContactSearch} control={<Checkbox defaultChecked={attr.is_show_search} />} />
              )
            }
          })}
        </Stack>
      </MenuPopover>
    </RootStyle>
  );
}
